<style scoped lang="scss">
  // @import "../user";
  .order{
    border-bottom: 1px solid #E4E6EA;
    border-top: 1px solid #E4E6EA;
    .top{
      display: flex;
      justify-content: space-between;
      align-items: center;
      border-bottom: 1px solid #E4E6EA;
      padding:10px 15px;
      dl{
        display: flex;
        dd{
          margin-right: 40px;
        }
      }
      .status{
        color: #014492;
        font-weight: bold;
      }
    }
    .products{
      li{
        display: flex;
        align-items: center;
        padding:15px;
        font-size: 12px;
        border-bottom: 1px solid #E4E6EA;
        &:last-child{
          border-bottom: 0;
        }
        .img-box{
          img{
            max-width: 60px;
            margin-right: 15px;
          }
        }
        .info{
          // flex:1;
          // border-right: 2px solid #E4E6EA;
          padding: 0 8px;
           &:last-child{
            border:0;
          }
        }
        .title{
          font-size: 12px;
        }
      }
      dl{
        display: flex;
        flex-wrap: wrap;
        dd{
          width:25%;
          margin-top:8px;
          label{
            color:#999;
          }
        }
      }
      &.multi{
        dl{
          dd{
            width:33.33%;
          }
        }
      }
    }
  }
  .badge {
    display: inline-block;
    width: 25px;
    height: 20px;
    padding: 3px 7px;
    font-size: 11px;
    font-weight: bold;
    color: #fff;
    line-height: 1;
    vertical-align: middle;
    white-space: nowrap;
    text-align: center;
    background-color: #777;
    border-radius: 10px;
}
.bg-orange-light {
    background-color: #014492;
    margin-right: 5px;
}
  // .products-lists{
  //   display: flex;
  //   font-size: 12px;
  //   .products{
  //     flex:1;
  //     border-right:1px solid #E4E6EA;
  //   }
  // }
  // .product{
  //   // display: flex;
  //   // align-items: center;
  //   .info{
  //     margin-left: 20px;
  //     text-align: left;
  //     // flex:1;
  //   }
  //   .title{
  //     font-size: 12px;
  //     font-weight: bold;
  //   }
  // }
  .el-input-number{
    width:120px;
  }
</style>
<template>
  <div class="user">
    <section>
      <h3 class="title">到货通知</h3>
      <div class="order">
        <div class="products-lists">
          <ul class="products multi">
            <li v-for="(itx) in orderLists" :key="itx.index">
              <div class="img-box">
                <img :src="itx.imgUrl">
              </div>
              <div class="info" style="flex:0.4">
                <div class="title" style="max-height: 40px;line-height: 20px;overflow: hidden;">{{itx.name}}</div>
                <div class="title" style="color: #919191;">{{itx.date}}</div>
              </div>
              <div class="info" style="flex:0.6;">
                <div style="display: flex">
                  <i class="el-icon-chat-dot-round" style="color:#014492;font-size: 15px;"></i>
                  <p class="title" style="max-height: 40px;line-height: 20px;overflow: hidden;">{{itx.comment}}</p>
                </div>
              </div>
              <div class="info">
                <span>编辑</span>
                <span>删除</span>
              </div>
            </li>
          </ul>
        </div>
      </div>
    </section>
  </div>
</template>

<script>
export default {
  data() {
    return {
      sendVisible: false,
      orderLists: [{name:'LABSELECT 11110 6孔细胞培养板 买2箱 赠送Biosharp BS-20-ST50 2ml细胞冻存管，外旋 1包买2箱 赠送Biosharp BS-20-ST50 2ml细胞冻存管，外旋 1包',date: '2021-11-27',comment:'真不错',imgUrl:'http://tsingke-shop.oss-cn-beijing.aliyuncs.com/11305---Qiagen%2074904%20%E6%A4%8D%E7%89%A9%E6%80%BBRNA%E5%B0%8F%E6%8F%90%E8%AF%95%E5%89%82%E7%9B%920.png',delete:false,look:false}
        ,{name:'Qiagen 74904 植物总RNA小提试剂盒',date: '2021-11-27',comment:'真不错',imgUrl:'http://tsingke-shop.oss-cn-beijing.aliyuncs.com/11304---Qiagen%2076104%20%E7%BB%84%E7%BB%87%E6%A0%B7%E5%93%81RNA%E7%A8%B3%E5%AE%9A%E6%B6%B20.png',delete:false,look:false}
        ,{name:'Qiagen 74904 ',date: '2021-11-27',comment:'真不错赠送Biosharp BS-20-ST50 2ml细胞冻存管，外旋 1包赠送Biosharp BS-20-ST50 2ml细胞冻存管，外旋 1包赠送Biosharp BS-20-ST50 2ml细胞冻存管，外旋 1包赠送Biosharp BS-20-ST50 2ml细胞冻存管，外旋 1包赠送Biosharp BS-20-ST50 2ml细胞冻存管，外旋 1包赠送Biosharp BS-20-ST50 2ml细胞冻存管，外旋 1包',imgUrl:'http://tsingke-shop.oss-cn-beijing.aliyuncs.com/11305---Qiagen%2074904%20%E6%A4%8D%E7%89%A9%E6%80%BBRNA%E5%B0%8F%E6%8F%90%E8%AF%95%E5%89%82%E7%9B%920.png',delete:false,look:false}
        ,{name:'Qiagen 74904 植物总RNA小提试剂盒',date: '2021-11-27',comment:'真不错',imgUrl:'http://tsingke-shop.oss-cn-beijing.aliyuncs.com/11305---Qiagen%2074904%20%E6%A4%8D%E7%89%A9%E6%80%BBRNA%E5%B0%8F%E6%8F%90%E8%AF%95%E5%89%82%E7%9B%920.png',delete:false,look:false}
        ,{name:'Qiagen 74904 植物总RNA小提试剂盒',date: '2021-11-27',comment:'真不错',imgUrl:'http://tsingke-shop.oss-cn-beijing.aliyuncs.com/11305---Qiagen%2074904%20%E6%A4%8D%E7%89%A9%E6%80%BBRNA%E5%B0%8F%E6%8F%90%E8%AF%95%E5%89%82%E7%9B%920.png',delete:false,look:false}
        ,{name:'Qiagen 74904 植物总RNA小提试剂盒',date: '2021-11-27',comment:'真不错',imgUrl:'http://tsingke-shop.oss-cn-beijing.aliyuncs.com/11305---Qiagen%2074904%20%E6%A4%8D%E7%89%A9%E6%80%BBRNA%E5%B0%8F%E6%8F%90%E8%AF%95%E5%89%82%E7%9B%920.png',delete:false,look:false}
        ,{name:'Qiagen 74904 植物总RNA小提试剂盒',date: '2021-11-27',comment:'真不错',imgUrl:'http://tsingke-shop.oss-cn-beijing.aliyuncs.com/11305---Qiagen%2074904%20%E6%A4%8D%E7%89%A9%E6%80%BBRNA%E5%B0%8F%E6%8F%90%E8%AF%95%E5%89%82%E7%9B%920.png',delete:false,look:false}
        ,{name:'Qiagen 74904 植物总RNA小提试剂盒',date: '2021-11-27',comment:'真不错',imgUrl:'http://tsingke-shop.oss-cn-beijing.aliyuncs.com/11305---Qiagen%2074904%20%E6%A4%8D%E7%89%A9%E6%80%BBRNA%E5%B0%8F%E6%8F%90%E8%AF%95%E5%89%82%E7%9B%920.png',delete:false,look:false}
        ,{name:'Qiagen 74904 植物总RNA小提试剂盒',date: '2021-11-27',comment:'真不错',imgUrl:'http://tsingke-shop.oss-cn-beijing.aliyuncs.com/11305---Qiagen%2074904%20%E6%A4%8D%E7%89%A9%E6%80%BBRNA%E5%B0%8F%E6%8F%90%E8%AF%95%E5%89%82%E7%9B%920.png',delete:false,look:false}
    ],
    }
  },
  created() {
  //http://8.130.53.158/product/detail/2602
  },
  methods: {
    // 删除订单
    bindDelete (id) {
      deleteProductOrders(id).then(() => {
        this.$message.success('删除成功！')
        this.getOrders()
      })
    },
  }
}
</script>



// WEBPACK FOOTER //
// src/views/user/arrivalNotice.vue